export default "__VITE_ASSET__BBq1ZbUl__"